export default __webpack_public_path__ + "e3e4583616c31893b83afb3ba03fc64c.png";